import type { ActionFunction } from '~/types/route-args';
import type { UpdateShoppingCartMutationVariables } from 'generated/graphql';
import { updateShoppingCart } from '@modules/ecommerce/api/update-shopping-cart.server';

export const UPDATE_SHOPPING_CART_API_ROUTE =
    '/remix-api/ecommerce/update-shopping-cart';

export type EcommerceUpdateShoppingCartAction = typeof action;

export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();
    const variables: UpdateShoppingCartMutationVariables = {};
    if (data.get('region')) {
        variables.region = Number(data.get('region'));
    }
    if (data.get('locality')) {
        variables.locality = Number(data.get('locality'));
    }
    return updateShoppingCart({
        ...context,
        variables,
    });
};
